import React, { useState, useEffect } from 'react'
import { Box, Paper, Text, Divider, SimpleGrid, Select, TextInput, Flex, Button, Input, Image } from '@mantine/core'
import { getAllCountryList } from '../../../../../services/location'
import { useSelector, useDispatch } from 'react-redux'
import { useUserTaxForm } from './schema/form'
import { Dropzone } from '@mantine/dropzone'
import { IconArrowNarrowRight, IconTrash } from '@tabler/icons-react'
import NoImage from '../../../../../assets/img/images/no-images.png'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { updateUser, submitUserCompany } from '../../../../../services/users'
import { getUserDetail } from '../../../../../store/userDetail'
import { useParams } from 'react-router-dom'

const defaultTaxAccountType = [
  {
    value: 'business',
    label: 'Business'
  },
  {
    value: 'individual',
    label: 'Individual'
  },
  {
    value: 'partnership',
    label: 'Partnership'
  }
]

const defaultIdType = [
  {
    value: 'NPWP',
    label: 'Taxprayer Identification Number (NPWP)'
  },
  {
    value: 'KTP',
    label: 'Identity Card (KTP)'
  },
]

const defaultTaxType = [
  {
    label: 'Non PKP / Pengusaha Kecil',
    value: 'false'
  },
  {
    label: 'PKP / Pengusaha Kena Pajak',
    value: 'true'
  }
]


const UserTaxInfo = () => {
  const params = useParams()
  const userId = params.id

  const dispatch = useDispatch()
  const { taxInfo } = useSelector((state) => state.user_detail)

  const form = useUserTaxForm()

  const [loadingForm, setLoadingForm] = useState(false)
  const [countryList, setCountryList] = useState([])

  const [newCompanyLogo, setNewCompanyLogo] = useState(null)

  const handleSubmitCompany = async (payload) => {

    const formData = new FormData()

    formData.append('name', payload.company_name)
    formData.append('country_id', payload.company_country)
    if (payload.new_company_logo !== null) {
      formData.append('logo', payload.new_company_logo)
    }
    if (payload.id === null) {
      formData.append('members[]', userId)
    }
    try {
      const response = await submitUserCompany(payload.id, formData)
      return response
    } catch (error) {
      console.log(error)
    }
  }

  const handleSubmitTaxUser = async (formData) => {
    setLoadingForm(true)

    const payload = {
      extras: {
        type_of_bussines: formData.type_of_bussines,
        registered_vat: formData.registered_vat,
        taxes_name: formData.taxes_name,
        taxes_address: formData.taxes_address,
        taxes_id: formData.taxes_id,
        identity_card: formData.identity_card,
      }
    }

    try {
      const response =await updateUser(userId, payload)
      if (response.success) {
        if (formData.type_of_bussines === 'business') {
          const payloadCompany = {
            id: taxInfo.companyId || null,
            company_name: formData.company_name,
            company_country: formData.company_country,
            new_company_logo: newCompanyLogo,
          }
          const responseCompany = await handleSubmitCompany(payloadCompany)
          if (responseCompany.success) {
            setLoadingForm(false)
            notificationSuccess('Update User Success', 'You have been updated data user')
            dispatch(getUserDetail(userId))
          }
        } else {
          setLoadingForm(false)
          notificationSuccess('Update User Success', 'You have been updated data user')
          dispatch(getUserDetail(userId))
        }
      }
    } catch (error) {
      setLoadingForm(false)
      const errorDescriptionMessage = 'There is an error while updating user'
      notificationError('Update User Error', errorDescriptionMessage)
    }
  }

  const handleGetCountryList = async () => {
    const params = {
      'page[num]': '1',
      'page[limit]': '99999',
    }
    try {
      const response = await getAllCountryList(params)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          label: val.attributes.name,
          value: `${val.attributes.id}`
        }
      })
      setCountryList(remapDataCountry)

    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (taxInfo) {
      handleSetForm(taxInfo)
    }
    // eslint-disable-next-line
  }, [taxInfo])

  useEffect(() => {
    if (form.getValues().type_of_bussines === 'business') {
      handleGetCountryList()
    }
    // eslint-disable-next-line
  }, [form.getValues().type_of_bussines])

  form.watch('id_type', ({ value }) => {
    if (value === 'KTP') {
      form.setValues((prev) => ({ ...prev, registered_vat: '' }))
    }
  })

  const handleSetForm = (dataTax) => {
    const data = {
      type_of_bussines: dataTax.typeOfBussines || 'individual',
      id_type: dataTax.identityCard !== null ? 'KTP' : 'NPWP',
      registered_vat: dataTax.registeredVat !== null ? dataTax.registeredVat === true ? 'true' : 'false' : '',
      taxes_name: dataTax.taxName || '',
      taxes_address: dataTax.taxAddress || '',
      identity_card:  dataTax.identityCard || null,
      taxes_id: dataTax.taxId || null,
      company_name: dataTax.companyName,
      company_country: dataTax.country ? `${dataTax.country}` : null,
      recent_company_logo: dataTax.companyLogo ? dataTax.companyLogo : null
    }

    form.initialize(data)
    form.setValues(data)
  }

  const handleUploadNewCompanyLogo = (file) => {
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      form.setValues((prev) => ({ ...prev, new_company_logo: reader.target.result }))
      setNewCompanyLogo(file[0])
    }
  }

  const handleErrorFile = (formData, file) => {
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      form.setFieldValue(formData, 'The maximum allowed image size is 2mb')
      notificationError('Upload Image Error', 'The maximum allowed image size is 2mb')
    }
  }

  const handlingScrolledError = (error) => {
    const errorField = Object.keys(error)[0]
    if (errorField) {
      const inputNode = form.getInputNode(errorField)
      if (inputNode) {
        inputNode.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  }

  const loadFormCompany = () => {

    const loadCompany_logo = () => {
      if (form.getValues().new_company_logo === null) {
        return (
          <Box ta='center' py={10}>
            <Flex justify='center'>
              <Image
                src={NoImage}
                height={195}
                w={500}
                fit='contain'
              />
            </Flex>
            <Box>
              <Text fz={12} c='blue.9'>Upload Logo Company Here</Text>
              <Text fz={12} c='gray.6'>PNG, JPG, GIF up to 1 MB</Text>
            </Box>
          </Box>
        )
      } else {
        return (
          <Image
            src={form.getValues().new_company_logo}
            height={250}
            w={500}
            fit='contain'
          />
        )
      }
    }

    return (
      <Paper my='xl' p='md' withBorder shadow='xs' radius='md'>
        <Text fw={500}>
          Company Information
        </Text>
        <Divider my='xs' />
        <SimpleGrid cols={4} verticalSpacing="sm" mb='md'>
          <Box>
            <TextInput
              label='Company Name'
              placeholder='Enter Company Name'
              size='xs'
              {...form.getInputProps('company_name')}
            />
          </Box>
          <Box>
            <Select
              name='company_country'
              label='Company Country'
              placeholder='Select Country'
              data={countryList}
              key={form.key('company_country')}
              {...form.getInputProps('company_country')}
              size='xs'
              searchable
              nothingFoundMessage="No Country Found"
              clearable
              withAsterisk
              allowDeselect={false}
            />
          </Box>
        </SimpleGrid>

        <Flex align='center' gap='md'>
          <Box>
            <Input.Wrapper
              label='Upload New Company Logo'
              size='xs'
              error={form.errors.new_company_logo}
            >
              <Paper withBorder shadow='xs' radius='md'>
                <Dropzone
                  accept={[
                    'image/png',
                    'image/jpeg',
                    'image/gif',
                  ]}
                  onDrop={(files) => handleUploadNewCompanyLogo(files)}
                  onReject={(files) => handleErrorFile('new_company_logo', files)}
                  maxSize={1000000}
                  style={{ border: 'none', backgroundColor: '#f4f4f4', padding: 0 }}
                >
                <Box ta='center'>
                  { loadCompany_logo() }
                  </Box>
                </Dropzone>
              </Paper>
            </Input.Wrapper>
            <Box mt={20} ta='center'>
              <Button
                size='xs'
                leftSection={<IconTrash size={14} />} 
                variant="filled"
                color='red'
                onClick={() => [form.setValues((prev) => ({ ...prev, new_company_logo: null })), setNewCompanyLogo(null)]} 
                disabled={form.getValues().new_company_logo === null}>Remove Logo</Button>
            </Box>
          </Box>

          <IconArrowNarrowRight size={30} />

          <Box mb={50}>
            <Input.Wrapper
              label='Current Company Logo'
              size='xs'
            >
              <Paper withBorder shadow='xs' radius='md'>
                <Image
                  src={form.getValues().recent_company_logo || NoImage}
                  height={250}
                  w={500}
                  fit={form.getValues().recent_company_logo === null ? 'cover' : 'contain'}
                />
              </Paper>
            </Input.Wrapper>
          </Box>
        </Flex>
      </Paper>
    )
  }

  return (
    <Box>
      <Paper my='xl' p='md' withBorder shadow='xs' radius='md'>
        <Text fw={500}>
          Tax Information
        </Text>
        <Divider my='xs' />
        <SimpleGrid cols={3} verticalSpacing="sm" mb='md'>
          <Box>
            <Select
              name='type_of_bussines'
              label='Tax Account Type'
              placeholder='Select type of bussiness'
              data={defaultTaxAccountType}
              key={form.key('type_of_bussines')}
              {...form.getInputProps('type_of_bussines')}
              size='xs'
              withAsterisk
              allowDeselect={false}
            />
          </Box>
          <Box>
            <Select
              name='id_type'
              label='ID Type'
              placeholder='Select ID Type'
              data={defaultIdType}
              key={form.key('id_type')}
              {...form.getInputProps('id_type')}
              size='xs'
              withAsterisk
              allowDeselect={false}
            />
          </Box>
          <Box>
            <Select
              name='registered_vat'
              label='Tax Type'
              placeholder='Select Tax Type'
              data={defaultTaxType}
              key={form.key('registered_vat')}
              {...form.getInputProps('registered_vat')}
              size='xs'
              withAsterisk
              allowDeselect={false}
              disabled={form.getValues().id_type === 'KTP'}
            />
          </Box>
          <Box>
            <TextInput
              name='taxes_name'
              label='Tax Name'
              placeholder='Enter Tax Name'
              size='xs'
              key={form.key('taxes_name')}
              {...form.getInputProps('taxes_name')}
              withAsterisk
            />
          </Box>
          <Box>
            <TextInput
              name={`${form.getValues().id_type === 'NPWP' ? 'taxes_id' : 'identity_card'}`}
              label={form.getValues().id_type === 'NPWP' ? 'Tax Number' : 'ID Number'}
              placeholder='Enter Number'
              size='xs'
              key={form.key(`${form.getValues().id_type === 'NPWP' ? 'taxes_id' : 'identity_card'}`)}
              {...form.getInputProps(`${form.getValues().id_type === 'NPWP' ? 'taxes_id' : 'identity_card'}`)}
              withAsterisk
              type='number'
            />
          </Box>
          <Box>
            <TextInput
              name='taxes_address'
              label='Tax Address'
              placeholder='Enter Tax Address'
              size='xs'
              key={form.key('taxes_address')}
              {...form.getInputProps('taxes_address')}
              withAsterisk
            />
          </Box>
        </SimpleGrid>
      </Paper>

      {form.getValues().type_of_bussines === 'business' ? loadFormCompany() : ''}

      <Box mt='xl'>
        <Flex justify='flex-end'>
          <Button
            size='xs'
            loading={loadingForm}
            variant="filled"
            onClick={form.onSubmit((value) => {
              handleSubmitTaxUser(value) 
            }, (error) => {
              handlingScrolledError(error)
            })}
            >
              Update
            </Button>
        </Flex>
      </Box>
    </Box>
  )
}

export default UserTaxInfo